export enum TournamentDurationType {
  Daily,
  Weekend,
  Hourly,
  Weekly
}


export enum TournamentEntryType {
  SingleBuyIn,
  Rebuy,
  FreeRoll,
  FreeRollWithEntryFee,
};
